module.exports = __webpack_public_path__ + "static/media/armani_vto_sidebar.9ace6d18.jpg";